(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.howlIntro = document.querySelector('howl-scroll-intro[data-enabled="true"]');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.onHowlIntroState = this.refreshHowlHeaderBounds.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      if (this.howlIntro) {
        window.addEventListener('howl:intro-state', this.onHowlIntroState);
        window.addEventListener('resize', this.onHowlIntroState);
      }

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      if (this.howlIntro) this.refreshHowlHeaderBounds();
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('howl:intro-state', this.onHowlIntroState);
      window.removeEventListener('resize', this.onHowlIntroState);
    }

    refreshHowlHeaderBounds() {
      this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      const top = this.header.getBoundingClientRect().top + window.scrollY;
      this.headerBounds = { top, bottom: top + this.header.offsetHeight };
      this.currentScrollTop = window.scrollY;
      if (this.headerIsAlwaysSticky && !['pending', 'active'].includes(document.documentElement.dataset.howlIntro)) {
        this.header.classList.add('shopify-section-header-sticky');
      }
    }

    createObserver() {
      if (this.howlIntro) { this.refreshHowlHeaderBounds(); return; }
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.howlIntro && ['pending', 'active'].includes(document.documentElement.dataset.howlIntro)) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["howl-editorial"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('howl-deferred-editorial'))customElements.define('howl-deferred-editorial',class extends HTMLElement{
    connectedCallback(){
      if(this.loaded)return;
      const template=this.querySelector('template');
      if(!template)return;
      this.load=()=>{
        if(this.loaded)return;
        this.loaded=true;clearTimeout(this.timer);this.observer?.disconnect();
        const content=template.content.cloneNode(true);
        content.querySelectorAll('img[data-howl-src]').forEach(image=>{
          image.src=image.getAttribute('data-howl-src');image.removeAttribute('data-howl-src');
        });
        this.append(content);template.remove();this.querySelector('noscript')?.remove();
      };
      if(window.Shopify?.designMode||!('IntersectionObserver' in window)){this.load();return}
      try{
        this.observer=new IntersectionObserver(entries=>{
          if(entries.some(entry=>entry.isIntersecting))this.load();
        },{rootMargin:'300px 0px'});
        this.observer.observe(this.closest('.howl-editorial__media')||this);
        this.timer=setTimeout(this.load,8000);
      }catch{this.load()}
    }
    disconnectedCallback(){clearTimeout(this.timer);this.observer?.disconnect()}
  });

  } catch(e) { console.error(e); }
})();
})();
